var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenborder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 7,
    viewBox: "0 0 235 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 7,
    rx: 3.5,
    fill: "#47B549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenborder2);
export default __webpack_public_path__ + "static/media/greenborder2.b3d08534f4b75de796025d26ab54f143.svg";
export { ForwardRef as ReactComponent };